import ALL_LOCATIONS from '@/graphql/locations/query/getAllSubLocations.gql'

export function apolloSubLocations(
  params: any,
  filterExists = false,
  filterSaved = null,
  fetchPolicy = null
) {
  return new Promise(async (resolve, reject) => {
    let apolloQuery
    let variables = {}
    try {
      variables = {
        orderBy: [
          {
            column: params.sortBy.toUpperCase(),
            order: params.sortDesc ? 'DESC' : 'ASC'
          }
        ],
        search: null,
        page: params.page,
        first: params.first
      }
      apolloQuery = ALL_LOCATIONS

      resolve(await query(apolloQuery, variables, { fetchPolicy }))
    } catch (err) {
      reject(err)
    }
  })
}

function subSelection() {
  return (
    '{\n' +
    '    data {\n' +
    '      uuid\n' +
    '      name\n' +
    '      language\n' +
    '      number_of_plans\n' +
    '      address {\n' +
    '        uuid\n' +
    '        latitude\n' +
    '        longitude\n' +
    '      }\n' +
    '      mainImage {\n' +
    '        uuid\n' +
    '        url\n' +
    '        file_mime_type' +
    '      }\n' +
    '      coverVideo {\n' +
    '        uuid\n' +
    '        url\n' +
    '        file_mime_type' +
    '      }\n' +
    '    }\n' +
    '    paginatorInfo {\n' +
    '      currentPage\n' +
    '      lastPage\n' +
    '      total\n' +
    '    }\n' +
    '  }'
  )
}
